import React, { FC } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { TokenError, TokenErrorStatus } from 'components/organisms/token-error';
import { useLoginWithToken } from 'hooks/use-login-with-token';
import { TokenType } from 'services';

export const LoginWithToken: FC<{ token: string; tokenType: TokenType }> = ({
  token,
  tokenType,
}) => {
  const [, isError] = useLoginWithToken(token, tokenType);

  if (isError) {
    return <TokenError status={TokenErrorStatus.Invalid} />;
  }

  return <PageLoading />;
};
